<template>
  <v-container
    id="towerServices"
    fluid
    tag="section"
  >
    <list-plans></list-plans>
  </v-container>
</template>

<script>
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'PlansHome',
    components: {
      ListPlans: () => import('@/components/list/Plans'),
    },
    mixins: [basicMixin],
    data () {
      return {
      }
    },
    computed: {
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
    },
    mounted () {
    },
    methods: {
    },
  }
</script>
